module.exports = __webpack_public_path__ + "img/emptybox.87b4f804.svg";